export class MetricExportDestinationSecretRef {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "SecretRefAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "SecretRefGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MetricExportDestinationSecretRef.attributeTypeMap;
    }
    constructor() {
    }
}
